import { loadStripe } from '@stripe/stripe-js';

let stripePromise;

/**
 * Returns a promise that resolves to the Stripe object.
 * The Stripe object is only loaded once, and subsequent calls to getStripe
 * will return the same promise.
 * #unused
 * @returns {Promise<Stripe>}
 */
const getStripe = () => {
  if(!stripePromise) {
    stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);
  }

  return stripePromise;
}

export default getStripe;